import { Link } from "@mui/material";
import { useDataProvider, useNotify, useRefresh } from "react-admin";

type NotificationRecord = {
  id_link?: number;
  titulo_notificacao?: string;
};

export const NotificationReadField = ({
  record,
}: {
  record?: NotificationRecord;
}) => {
  const dataProvider = useDataProvider();
  const refresh = useRefresh();
  const notify = useNotify();

  if (!record?.id_link) return null;

  const open = async () => {
    try {
      const { data } = await dataProvider.getOne("notifications", {
        id: record.id_link,
      });
      refresh();
      if (data.url_destino) window.open(String(data.url_destino), "_blank");
    } catch {
      notify("Erro ao abrir notificação", { type: "warning" });
    }
  };

  return (
    <Link component="button" variant="body2" onClick={open}>
      {record.titulo_notificacao}
    </Link>
  );
};
